/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ServerInformation,
} from '../models';
import {
    ServerInformationFromJSON,
    ServerInformationToJSON,
} from '../models';

/**
 * 
 */
export class InfoControllerApi extends runtime.BaseAPI {

    /**
     * returns information about the deployed server version
     * returns information about the deployed server version
     */
    async getInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServerInformation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServerInformationFromJSON(jsonValue));
    }

    /**
     * returns information about the deployed server version
     * returns information about the deployed server version
     */
    async getInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServerInformation> {
        const response = await this.getInfoRaw(initOverrides);
        return await response.value();
    }

}
